module.exports = __webpack_public_path__ + "static/media/canadian_flag.a70647df.svg";